import { AllocationHistory } from "types/AllocationHistory";
import { AssetClass } from "types/AssetClass";
import { createCustomAction } from "typesafe-actions";

const ALLOCATIONHISTORY_DATA_LOAD = "ALLOCATIONHISTORY/ALLOCATIONHISTORY_DATA_LOAD";
const ALLOCATIONHISTORY_DATA_LOAD_SUCCESS = "ALLOCATIONHISTORY/ALLOCATIONHISTORY_DATA_LOAD_SUCCESS";
const ALLOCATIONHISTORY_DATA_LOAD_FAIL = "ALLOCATIONHISTORY/ALLOCATIONHISTORY_DATA_LOAD_FAIL";

export type AllocationHistoryContentType = "all" | keyof typeof AssetClass;

export const load = createCustomAction(
  ALLOCATIONHISTORY_DATA_LOAD,
  (type) => (contentType: AllocationHistoryContentType) => ({
    type,
    contentType,
  })
);

export const loadSuccess = createCustomAction(
  ALLOCATIONHISTORY_DATA_LOAD_SUCCESS,
  (type) => (contentType: AllocationHistoryContentType, data?: AllocationHistory[]) => ({
    type,
    contentType,
    data,
  })
);

export const loadFail = createCustomAction(
  ALLOCATIONHISTORY_DATA_LOAD_FAIL,
  (type) => (contentType: AllocationHistoryContentType, error?: string) => ({
    type,
    contentType,
    error,
  })
);
